<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Incluir pedidos de revisão</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Incluir Pedidos de Revisão',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnGoBack" type="button" color="primary" elevation="0" outlined
                                    to="/revisao-credito">Voltar</v-btn>
                            </template>
                            <span>Voltar</span>
                        </v-tooltip>
                    </div>
                </div>

            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined">
                    <v-card-title class="card-title d-flex align-center">
                        <span>Pedidos de Revisão - Importar e Processar Arquivo CSV</span>

                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="primary" class="ml-2 cursor-pointer"
                                    @click="showCsvHelp = true">
                                    mdi-help-circle-outline
                                </v-icon>
                            </template>
                            <span>Ver exemplos do arquivo CSV</span>
                        </v-tooltip>
                    </v-card-title>

                    <v-card-text>
                        <v-alert dense elevation="1" class="mb-4 custom-alert">
                            <template v-slot:prepend>
                                <v-icon color="#FFFFFF">mdi-information</v-icon>
                            </template>
                            <strong>Formato esperado do arquivo CSV:</strong>
                            <ul class="mt-2">
                                <li>Separado por ponto e vírgula (;)</li>
                                <li>Cabeçalho: <strong>cpf_cnpj</strong> | <strong>origem</strong> |
                                    <strong>valor</strong> |
                                    <strong>moeda</strong> | <strong>classe</strong> | <strong>identificacao</strong> |
                                    <strong>empresa</strong> |
                                    <strong>justificativa</strong> | <strong>documentos</strong> (link dos documentos
                                    separados por ",")
                                </li>
                                <li>Máximo de {{ maxRecords }} registros por arquivo</li>
                                <li>Codificação: UTF-8</li>
                                <br/>
                                <li>
                                    Justificativas
                                    <br />
                                    <strong>
                                        •⁠ ⁠Alteração de classe
                                    </strong>
                                    <br />
                                    <strong>
                                        •⁠ ⁠Pagamento integral por terceiro em processo judicial
                                    </strong>
                                    <br />
                                    <strong>
                                        •⁠ ⁠Pagamento parcial por terceiro em processo judicial
                                    </strong>
                                    <br />
                                    <strong>
                                        •⁠ ⁠Pagamento integral pelas Recuperandas em processo judicial
                                    </strong>
                                    <br />
                                    <strong>
                                        •⁠ ⁠Pagamento parcial pelas Recuperandas em processo judicial
                                    </strong>
                                    <br />
                                    <strong>
                                        •⁠ ⁠Bloqueio sem liberação em processo judicial
                                    </strong>
                                </li>
                            </ul>
                        </v-alert>
                        <v-file-input v-model="file" label="Selecionar arquivo CSV" accept=".csv" :rules="fileRules"
                            @change="handleFileUpload" show-size truncate-length="50" class="file-input-custom"
                            prepend-icon="mdi-file-document-outline" :loading="loading" :chips="true"
                            counter></v-file-input>

                        <v-card v-if="processingSummary.total > 0" outlined class="mt-4 pa-4">
                            <h3 class="subtitle-1 mb-2">Resumo da importação do arquivo</h3>
                            <v-row>
                                <v-col cols="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="text-h6 primary--text">{{ processingSummary.total }}</div>
                                        <div class="text-subtitle-2">Total de registros</div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="text-h6 success--text">{{ processingSummary.valid }}</div>
                                        <div class="text-subtitle-2">Registros válidos</div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="text-h6 error--text">{{ processingSummary.invalid }}</div>
                                        <div class="text-subtitle-2">Registros com erro</div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-data-table v-if="errors.length > 0" :headers="errorTableHeaders" :items="errors" class="mt-5"
                            dense>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Registros com erro</v-toolbar-title>
                                </v-toolbar>
                            </template>
                        </v-data-table>

                        <v-alert v-if="errorMessage" type="error" class="mt-4" dense>
                            <span v-html="errorMessage"></span>
                        </v-alert>

                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" color="primary" class="mt-4"
                                    :disabled="!canProcess || errors.length > 0" @click="processData"
                                    :loading="processing">
                                    Processar Dados
                                </v-btn>
                            </template>
                            <span>Enviar dados para processamento</span>
                        </v-tooltip>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modal de resultado -->
        <v-dialog v-model="dialog" persistent max-width="800">
            <v-card>
                <v-card-title>
                    <span v-if="errorsBack.length > 0" class="text-h6">Erro(s) no processamento</span>
                    <span v-else class="text-h6">Processamento Concluído</span>
                </v-card-title>
                <v-card-text>
                    <div>
                        Processamento concluído. Pedidos processados:
                        <strong>{{ processedCount }}</strong>,
                        com erros:
                        <strong>{{ errorsBack.length }}</strong>.
                    </div>
                    <br>
                    <div v-if="errorsBack.length > 0">
                        <p>Os seguintes erros foram encontrados:</p>
                        <v-data-table :headers="errorBackTableHeaders" :items="errorsBack" dense class="mt-3">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.cpf_cnpj }}</td>
                                    <td class="text-left">{{ item.error }}</td>
                                </tr>
                            </template>

                        </v-data-table>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showCsvHelp" max-width="950">
            <v-card>
                <v-card-title class="text-h6">
                    Exemplo de preenchimento do arquivo CSV
                </v-card-title>

                <v-card-text>
                    <p class="mb-3">
                        O arquivo CSV deve conter <strong>exatamente</strong> os campos abaixo,
                        separados por <strong>ponto e vírgula (;)</strong>.
                    </p>

                    <v-alert dense type="info" class="mb-4">
                        <strong>Ordem das colunas:</strong><br>
                        cpf_cnpj; origem; valor; moeda; classe; identificacao; empresa; justificativa; documentos
                    </v-alert>

                    <!-- Tabela de exemplo -->
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>cpf_cnpj</th>
                                <th>origem</th>
                                <th>valor</th>
                                <th>moeda</th>
                                <th>classe</th>
                                <th>identificacao</th>
                                <th>empresa</th>
                                <th>justificativa</th>
                                <th>documentos</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>12345678901</td>
                                <td>reclamatória trabalhista</td>
                                <td>1500.50</td>
                                <td>real</td>
                                <td>trabalhista</td>
                                <td>123456</td>
                                <td>MM Turismo</td>
                                <td>Alteração de classe</td>
                                <td>Doc01,Doc03</td>
                            </tr>
                            <tr>
                                <td>98765432000199</td>
                                <td>reserva de hotel</td>
                                <td>2300</td>
                                <td>dolar</td>
                                <td>quirografário</td>
                                <td>9876543</td>
                                <td>Lance Hoteis</td>
                                <td>Alteração de classe</td>
                                <td>Doc02</td>
                            </tr>
                            <tr>
                                <td>98765432000199</td>
                                <td>venda de milhas</td>
                                <td>1500</td>
                                <td>euro</td>
                                <td>me/epp</td>
                                <td>0001350</td>
                                <td>123 Milhas</td>
                                <td>Alteração de classe</td>
                                <td>Documento comprobatório</td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <v-divider class="my-4"></v-divider>

                    <!-- Exemplo em texto copiável -->
                    <!-- <p><strong>Exemplo em formato texto:</strong></p>

                    <v-card outlined class="pa-3 grey lighten-4">
                        <pre style="white-space: pre-wrap; font-size: 13px;">
                        cpf_cnpj;origem;valor;moeda;classe;identificacao;empresa;observacao;documentos
                        12345678901;BANCO XYZ;15000.50;BRL;3;REQ-001;Empresa ABC LTDA;Revisão de valor;Doc01,Doc03
                        98765432000199;FINANCEIRA XP;23000;USD;4;REQ-002;XP Holdings;Ajuste contratual;Doc02
        </pre>
                    </v-card> -->

                    <v-alert type="warning" dense class="mt-4">
                        ⚠️ O campo <strong>documentos</strong> deve conter os valores separados por vírgula (,).
                        Exemplo: <strong>Doc01,Doc03</strong>
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showCsvHelp = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>


<script>
import Vue from "vue";
import VueLodash from 'vue-lodash';
import _ from 'lodash';
import axios from 'axios';
import { cpf, cnpj } from 'cpf-cnpj-validator';

Vue.use(VueLodash);

export default {
    name: "ObjectionEventCreateMultiple",

    data() {
        return {
            errorsBack: [],
            dialog: false,
            file: null,
            processedCount: null,
            processedData: [],
            allowedJustificativas: [],
            csvData: [],
            loading: false,
            processing: false,
            errors: [],
            errorMessage: "",
            showCsvHelp: false,
            maxRecords: 100,
            maxFileSize: 5 * 1024 * 1024, // 5MB
            processingSummary: {
                total: 0,
                valid: 0,
                invalid: 0
            },
            dataset: {
                loading: null,
            },
            errorTableHeaders: [
                { text: "Linha", value: "line", width: "80px" },
                { text: "Erro(s)", value: "errors" },
            ],
            errorBackTableHeaders: [
                { text: 'CPF/CNPJ', value: 'cpf_cnpj' },
                { text: 'Erro', value: 'error' }
            ],
            breadcrumbItems: [
                {
                    text: 'Homepage',
                    disabled: false,
                    to: '/home',
                    exact: true,
                },
                {
                    text: 'Incluir Lista',
                    disabled: true,
                    exact: true,
                },
            ],
            fileRules: [
                v => !!v || 'Arquivo é obrigatório.',
                v => !v || v.size <= this.maxFileSize || 'Arquivo muito grande! Máximo 5MB.',
                v => !v || v.type === 'text/csv' || 'Formato inválido! Apenas CSV é aceito.'
            ],
            expectedHeaders: ['cpf_cnpj', 'origem', 'valor', 'moeda', 'classe', 'identificacao', 'empresa', 'justificativa', 'documentos']
        };
    },

    created() {
        this.allowedJustificativas = [
            'Alteração de classe',
            'Pagamento integral por terceiro em processo judicial',
            'Pagamento parcial por terceiro em processo judicial',
            'Pagamento integral pelas Recuperandas em processo judicial',
            'Pagamento parcial pelas Recuperandas em processo judicial',
            'Bloqueio sem liberação em processo judicial'
        ];
    },

    computed: {
        canProcess() {
            return this.file &&
                !this.loading &&
                !this.processing &&
                this.errorMessage.length === 0 &&
                this.processingSummary.valid > 0;
        }
    },

    methods: {
        async handleFileUpload() {
            if (!this.file) {
                this.errorMessage = "Nenhum arquivo foi selecionado.";
                return;
            }

            this.loading = true;
            this.errors = [];
            this.errorMessage = "";
            this.processingSummary = { total: 0, valid: 0, invalid: 0 };

            try {
                const content = await this.readFileContent(this.file);
                const parsedData = this.parseCSV(content);

                if (!parsedData.success) {
                    this.errorMessage = parsedData.message;
                    this.errors = parsedData.errors;
                    return;
                }

                this.updateProcessingSummary(parsedData);

                this.errors = parsedData.errors;

            } catch (error) {
                this.errorMessage = "Erro ao processar arquivo: " + error.message;
            } finally {
                this.loading = false;
            }
        },

        readFileContent(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    try {
                        const content = e.target.result;
                        resolve(content);
                    } catch (error) {
                        reject(new Error('Erro ao ler conteúdo do arquivo'));
                    }
                };

                reader.onerror = () => {
                    reject(new Error('Erro ao ler arquivo'));
                };

                reader.readAsText(file, 'UTF-8');
            });
        },

        parseCSV(data) {
            const lines = data.split("\n").filter(line => line.trim());
            const firstLine = lines[0];
            const separator = firstLine.includes(';') ? ';' : ',';
            const headers = lines[0].split(separator)
                .map(h => h.trim().toLowerCase())
                .filter(h => h);

            if (!this.validateHeaders(headers)) {
                return {
                    success: false,
                    message: `Cabeçalho do arquivo inválido! <br> - Encontrado: ${headers.join(separator)} <br> - Esperado: ${this.expectedHeaders.join(separator)}`,
                    errors: [{
                        line: 1,
                        errors: `Cabeçalho esperado: ${this.expectedHeaders.join(separator)}`
                    }]
                };
            }

            if (lines.length - 1 > this.maxRecords) {
                return {
                    success: false,
                    message: `O arquivo excede o limite de ${this.maxRecords} registros permitidos.`,
                    errors: []
                };
            }

            const result = [];
            const errors = [];
            const validRecords = [];

            for (let i = 1; i < lines.length; i++) {

                let row = this.splitCSVRow(lines[i], separator);

                if (row.length !== headers.length) {
                    errors.push({
                        line: i + 1,
                        errors: `Número incorreto de colunas. Esperado: ${headers.length}, Encontrado: ${row.length}`
                    });
                    continue;
                }

                const record = this.createRecord(row, i + 1);

                const documentosIndex = headers.indexOf("documentos");

                if (documentosIndex !== -1 && record.documentos) {
                    record.documentos = record.documentos
                        .split(',')
                        .map(doc => doc.trim())
                        .filter(doc => doc);
                }

                const validation = this.validateRecord(record);

                if (validation.isValid) {
                    result.push(record);
                    validRecords.push({
                        //id: record.id,
                        cpf_cnpj: record.cpf_cnpj,
                        origin: record.origem,
                        amount: record.valor,
                        currency: record.moeda,
                        type: record.classe,
                        request_number: record.identificacao,
                        company: record.empresa,
                        observation: record.justificativa,
                        documents: record.documentos,
                    });
                } else {
                    errors.push({
                        line: i + 1,
                        errors: validation.errors.join("; ")
                    });
                }
            }

            this.processedData = validRecords;

            return {
                success: true,
                validData: result,
                errors,
                count: {
                    total: lines.length - 1,
                    valid: validRecords.length,
                    invalid: errors.length
                }
            };
        },

        splitCSVRow(row, separator) {

            const regex = new RegExp(
                `(?:${separator}|\\r?\\n|^)(?:"([^"]*(?:""[^"]*)*)"|([^"${separator}\\r\\n]*))`,
                "g"
            );

            const result = [];
            let match;

            while ((match = regex.exec(row))) {
                if (match[1] !== undefined) {
                    result.push(match[1].replace(/""/g, '"'));
                } else {
                    result.push(match[2]);
                }
            }

            const expectedColumnCount = 4;
            while (result.length < expectedColumnCount) {
                result.unshift(null);
            }

            return result.map(cell => (cell ? cell.trim() : null));
        },

        validateHeaders(headers) {
            const expectedHeadersLower = this.expectedHeaders.map(h => h.toLowerCase());
            const headersLower = headers.map(h => h.toLowerCase());

            return expectedHeadersLower.every(expected =>
                headersLower.includes(expected)
            );
        },

        validateRecord(record) {
            const errors = [];

            if (!this.validateCpfCnpj(record.cpf_cnpj)) {
                errors.push("CPF/CNPJ inválido ou mal formatado");
            }

            if (!record.origem || record.origem.trim().length < 3) {
                errors.push("Origem do negócio deve ser preenchido e ter no mínimo 3 caracteres!");
            }

            if (!record.valor) {
                errors.push("Valor deve ser preenchido!");
            }

            if (!record.moeda) {
                errors.push("Campo 'Moeda' deve ser preenchido com: 'real', 'dolar', 'euro'!");
            }

            if (record.classe !== 1 && record.classe !== 2 && record.classe !== 3 && record.classe !== 4) {
                errors.push("Classe deve ser: 'Trabalhista', 'Garantia Real', 'Quirografário', 'ME/EPP'");
            }

            // justificativa must match one of the allowed phrases (case-insensitive, trimmed)
            if (!record.justificativa || typeof record.justificativa !== 'string') {
                errors.push("Campo 'Justificativa' deve ser preenchido e corresponder a uma justificativa válida!");
            } else {
                const normalized = record.justificativa.trim().toLowerCase();
                const match = this.allowedJustificativas.some(j => j.trim().toLowerCase() === normalized);
                if (!match) {
                    errors.push("Campo 'Justificativa' inválido. Deve ser uma das justificativas permitidas.");
                }
            }

            if (!record.empresa || record.empresa.trim().length < 3) {
                errors.push("Campo 'Empresa Devedora' deve ser preenchido e ter no mínimo 3 caracteres!");
            }

            if (
                !record.documentos ||
                !Array.isArray(record.documentos) ||
                record.documentos.length === 0
            ) {
                errors.push("O campo 'documentos' está vazio ou ausente!");
            }

            return {
                isValid: errors.length === 0,
                errors
            };
        },

        createRecord(row, lineNumber) {
            return {
                cpf_cnpj: this.normalizeValue(row[0]),
                origem: row[1],
                valor: this.normalizeCurrency(row[2]),
                moeda: this.convertCurrency(row[3]),
                classe: this.convertType(row[4]),
                identificacao: row[5],
                empresa: this.normalizeCompanyName(row[6]),
                justificativa: row[7],
                documentos: row[8],
                line: lineNumber
            };
        },

        normalizeCurrency(value) {
            if (!value || typeof value !== 'string') {
                return null;
            }

            let normalized = value.replace(/[^\d,.-]/g, "").trim();

            normalized = normalized.replace(",", ".");

            if ((normalized.match(/\./g) || []).length > 1) {
                normalized = normalized.replace(/\.(?=\d{3})/g, "");
            }

            const result = parseFloat(normalized);

            return isNaN(result) ? null : parseFloat(result.toFixed(2));
        },


        convertCurrency(value) {

            if (!value || typeof value !== 'string' || value.trim() === "") {
                return 0;
            }

            const currencyLower = value.trim().toLowerCase();

            if (currencyLower === "real") {
                return 1;
            }

            if (currencyLower === "dólar" || currencyLower === "dolar") {
                return 2;
            }

            if (currencyLower === "euro") {
                return 3;
            }

            return 5;
        },

        convertType(value) {

            if (!value || typeof value !== 'string' || value.trim() === "") {
                return 0;
            }

            const typeLower = value.trim().toLowerCase();

            if (typeLower === "classe i" || typeLower === "trabalhista" || typeLower === "trabalhistas") {
                return 1;
            }

            if (typeLower === "classe ii" || typeLower === "garantia real") {
                return 2;
            }

            if (typeLower === "classe iii" || typeLower === "quirografário" || typeLower === "quirografario" || typeLower === "quirografarios") {
                return 3;
            }

            if (typeLower === "classe iv" || typeLower === "me/epp") {
                return 4;
            }

            return 5;
        },

        normalizeCompanyName(value) {
            if (!value || typeof value !== 'string') {
                return '';
            }

            const text = value.trim().toLowerCase();

            if (text.includes('123 viagens' || '123 milhas')) {
                return '123 VIAGENS E TURISMOS LTDA';
            }

            if (text.includes('mm turismo')) {
                return 'MM TURISMO & VIAGENS S.A';
            }

            if (text.includes('novum')) {
                return 'NOVUM INVESTIMENTOS PARTICIPAÇÕES S/A';
            }

            if (text.includes('art viagens')) {
                return 'ART VIAGENS E TURISMO LTDA';
            }

            if (text.includes('lance')) {
                return 'LH - LANCE HOTÉIS LTDA';
            }

            return value;
        },

        normalizeValue(value) {
            if (!value || typeof value !== 'string') {
                return "";
            }

            return value.replace(/[^\d]/g, "");
        },

        validateCpfCnpj(value) {
            const normalizedValue = this.normalizeValue(value);

            return normalizedValue.length === 11 ?
                cpf.isValid(normalizedValue) :
                cnpj.isValid(normalizedValue);
        },

        updateProcessingSummary(parsedData) {
            this.processingSummary = {
                total: parsedData.count.total,
                valid: parsedData.count.valid,
                invalid: parsedData.count.invalid
            };
        },

        async processData() {
            if (!this.canProcess) return;

            this.processing = true;

            try {

                if (this.processedData.length === 0) {
                    this.$dialog.notify.error("Dados processados com sucesso!", {
                        position: "top-right",
                        timeout: 3000
                    });
                }

                const payload = {
                    records: this.processedData,
                    totalRecords: this.processedData.length
                };

                const response = await axios.post('/api/admin/user-objection-events/client-analise-multiple', payload);

                const data = response.data;

                if (data.status && data.content) {

                    this.processedCount = data.content.processedCount;

                    if (data.content.errors && data.content.errors.length > 0) {

                        this.errorsBack = data.content.errors.map((errorItem) => ({
                            cpf_cnpj: errorItem.record.cpf_cnpj,
                            origem: errorItem.record.origem,
                            valor: errorItem.record.valor,
                            moeda: errorItem.record.moeda,
                            classe: errorItem.record.classe,
                            identificacao: errorItem.record.identificacao,
                            empresa: errorItem.record.empresa,
                            justificativa: errorItem.record.justificativa,
                            documentos: errorItem.record.documentos,
                            error: errorItem.error
                        }));

                    } else {
                        this.errorsBack = [];
                    }

                } else {
                    throw new Error("Erro ao enviar dados para o servidor");
                }

                this.clearForm();

            } catch (error) {
                this.$dialog.notify.error("Erro ao processar dados: " + error.message, {
                    position: "top-right",
                    timeout: 5000
                });
            } finally {
                this.dialog = true;
                this.processing = false;
            }
        },

        clearForm() {
            this.file = null;
            this.processedData = [];
            this.errors = [];
            this.errorMessage = "";
            this.processingSummary = { total: 0, valid: 0, invalid: 0 };
        },
    }
};
</script>

<style>
.card-form-outlined {
    padding: 20px;
}

.card-title {
    padding-bottom: 8px !important;
    display: flex !important;
    font-weight: 650 !important;
    font-size: 20px !important;
    font-style: bold !important;
    color: var(--v-primary-base) !important;
}

.drop-area {
    border: 2px dashed #757575;
    padding: 20px;
    text-align: left;
}

.file-input-custom ::v-deep .v-file-input__text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: none;
}

.file-count {
    margin-top: 10px;
    font-size: 14px;
    text-align: right;
}

.custom-alert {
    background-color: #4DB6AC !important;
    color: #ffffff !important;
}
</style>